export default {
  isSound: false,
  life: null,
  score: null
};
